import { PAGE_SIZE } from './accounts.config';

export const updateState = <T extends Object>(state: T, patch: Partial<T>): T => ({
  ...state,
  ...patch,
});

export const sortByName = <T extends { name: string }>(list: T[]): T[] => {
  return [...list].sort((a, b) => a.name.localeCompare(b.name) > 0 ? 1 : -1);
}

export const getVisibleAccounts = <T extends { name: string }>(list: T[], searchTerm: string, page: number): T[] => {
  const filter = searchTerm.toLowerCase().trim() || '';

  return [...list]
    .filter(item => item.name.toLowerCase().includes(filter))
    .slice(0, page * PAGE_SIZE);
}
